<template>
    <!-- <div id="header-block"></div> -->

    <nav class="navbar navbar-expand-lg sticky-top" v-bind:class="{ navbarOpen: navShow }">
        <a class="navbar-brand" href="#" style='margin-left: 30px'>Aoyu Wu</a>
        <button
            class="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarSupportedContent"
            @click.stop="toggleNavbar()"
        >
            <span class="navbar-toggler-icon"></span>
        </button>
        <div
            class="collapse navbar-collapse"
            id="navbarSupportedContent"
            v-bind:class="{ show: navShow }"
        >
            <ul class="navbar-nav ms-auto">
                <li class="nav-item active">
                    <a class="nav-link" href="#">Home <span class="sr-only">(current)</span></a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="#sec-news">News</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="#sec-research">Research</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="#sec-awards">Awards</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="#sec-press">Press</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="#sec-service">Service</a>
                </li>
            </ul>
        </div>
    </nav>

    <div id="body">
        <div class="col-sm-none">
            <div class="row myrow" id="row-profile">
                <div class="col-9">
                    <Hello />
                    <Intro />
                </div>
                <div class="col-3">
                    <Photo />
                </div>
            </div>

            <div class="myrow row">
                <div class="col-12">
                    <News />
                    <Publication />
                    <Awards />
                    <Media />
                    <Service />
                    <Gallery />
                    <Teaching />
                </div>
                <!-- <div class="col-3">
                    <News />
                    <Teaching />
                </div> -->
            </div>
        </div>

        <div class="col-sm-only">
            <div class="row myrow" id="row-profile">
                <div class="col-12">
                    <Hello />

                    <div height="200px">
                        <Photo />
                    </div>
                    <Intro />
                </div>
            </div>
            <div class="row myrow">
                <div class="col-12" style="padding-top: 0px">
                    <Publication />
                    <Awards />
                    <Media />
                    <News />

                    <Teaching />
                    <Service />
                </div>
            </div>
        </div>

        <!-- <div class="container-fluid">
      <div style="padding-bottom: 20px">
        <span class="heading-text"
          >Hi, I am <span class="highlight-text">Aoyu Wu</span>.</span
        >
      </div>

      <div class="row">
        <div class="col-sm col-md-8">
          <Intro />
        </div>
        <div class="col-sm col-md-4">
          <Photo />
        </div>
      </div>

      <div class="row">
        <div class="col-sm col-md-8">
          <Publication />

          <Gallery />
        </div>
        <div class="col-sm col-md-4">
          <News />

          <Awards />

          <Teaching />

          <Service />
        </div>
      </div>
    </div> -->
    </div>

    <footer class="footer h-100">
        <div class="align-middle justify-content-center align-self-center text-center">
            Last updated on Mar 2023.
        </div>
    </footer>
</template>

<script lang="ts">
import $ from "jquery";
import "bootstrap/dist/css/bootstrap.css";
import { useHead } from "@vueuse/head";
// import { Head } from "@egoist/vue-head";

import { defineComponent } from "vue";
import { useStore } from "vuex";

import Intro from "./App/Intro.vue";
import Photo from "./App/Photo.vue";
import Publication from "./App/Publication.vue";
import News from "./App/News.vue";
import Awards from "./App/Awards.vue";
import Teaching from "./App/Teaching.vue";
import Service from "./App/Service.vue";
import Gallery from "./App/Gallery.vue";
import Media from "./App/Media.vue";
import Hello from "./App/Hello.vue";

import { onMounted, computed, reactive, toRefs, h, watch } from "vue";

export default defineComponent({
    name: "App",
    components: {
        Intro,
        Photo,
        Publication,
        News,
        Awards,
        Teaching,
        Service,
        Gallery,
        Media,
        Hello,
    },
    setup() {
        const store = useStore();

        const state = reactive({
            svgStr: computed(() => store.state.svgStr),
            navShow: false,
        });

        const siteData = reactive({
            title: `Aoyu Wu's Home Page`,
            description: `I am a PhD candidate in Computer Science at the Hong Kong University of Science and Technology (since 2019), supervised by Prof. QU Huamin. I am an awardee of the Hong Kong PhD Fellowship Scheme.`,
        });

        useHead({
            // Can be static or computed
            title: computed(() => siteData.title),
            meta: [
                {
                    name: `description`,
                    content: computed(() => siteData.description),
                },
                {
                    name: "keywords",
                    content: "WU AOYU",
                },
            ],
        });

        const toggleNavbar = () => {
            state.navShow = !state.navShow;
        };

        return {
            ...toRefs(state),
            toggleNavbar,
        };
    },
    computed: {},
});
</script>

<style rel="stylesheet" lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap");

$blue: #263459;
$color1: #96351e;
$color2: #dbb98f;

html,
body {
    // overflow-y: scroll;
    overflow-x: hidden;

    width: 100vw;

    font-family: "Roboto", sans-serif;
    font-size: 16px;
    background: #f5f5f7;

    color: #1d1d1f;
}

nav {
    // height: 10px;
    // width: 100%;
    background-color: $blue;
    padding: 0px 20px;

    a {
        color: #f5f5f7 !important;
    }
}

@media all and (min-width: 768px) {
    // margin: 0px 100px;
    div.myrow {
        margin-left: 30px;
        margin-right: 30px;
        margin-top: 30px;
        margin-bottom: 30px;
    }

    div.col-sm-only {
        display: none;
    }

    div.section {
        padding-right: 60px;
        padding-left: 60px;
        padding-bottom: 10px;
        padding-top: 10px;
    }
}

@media all and (max-width: 768px) {
    div.myrow {
        margin: 20px 10px;
    }

    div.col-sm-none {
        display: none;
    }

    div.section {
        padding: 10px 20px;
    }
}

div#body {
    width: 100vw;
    overflow: hidden;
}

.heading-text {
    font-weight: 500;
    font-size: 2.4em;
}

.section-sub-head {
    font-weight: 500;
    font-size: 1.2em;    
    padding-bottom: 0.5em;
    color: $blue; 
}

.section-head {
    font-weight: 500;
    font-size: 1.6em;
    padding-bottom: 10px;

    color: $blue; // $color1;

    &::before {
        display: block;
        height: 4rem;
        margin-top: -4rem;
        visibility: hidden;
        content: "";
    }

    &.section-head-padding {
        padding-top: 30px;
        padding-bottom: 10px;
    }

    // mark {
    //     // display: inline-block;
    //     // line-height: 0em;
    //     // padding-bottom: 0.5em;
    //     // // vertical-align: 0.2em;
    //     // background-color:$color2;
    // }

    & > span {
        // background: url("~@/assets/background.png");

        // background: url(/assets/background.png);
        background-repeat: no-repeat;
        background-size: 100% 100%;
        padding: 8px 0;
    }
}

//    .section-head > span {
//         // background-color: none;
//         position: relative;
//         z-index: 0;
//     }

//     .section-head > span::after {
//         background-color: $color2;
//         content: "";
//         height: 30%;
//         position: absolute;
//         left: 0;
//         margin-left: -0.2rem;
//         top: 65%;
//         width: calc(100% + 0.5rem);
//         z-index: -1;
//     }

div#row-profile {
    // padding-top: 40px;
    padding-bottom: 20px;
    border-bottom: #aaa 1px solid;
}

.highlight-text {
    border-bottom: 3px solid $color1;
    text-decoration: none !important;
}

span.url {
    color: $color1;
    // border-bottom: 2px solid $color2;
}


a.url {
    // display: inline-block;
    color: $color1;
    // font-weight: 900;
    text-decoration: none;
    // border-bottom: 2px solid $color2;
    // position: relative;

    // &::after {
    //     content: "";
    //     display: block;
    //     width: 0;
    //     height: 3px;
    //     background: $color1;
    //     transition: width 0.3s;
    //     position: absolute;
    // }

    &:hover {
        text-decoration: underline;
        text-decoration-color: $color1;
        text-decoration-thickness: 2px;
        // border-bottom: 2px solid $color2;
        // text-decoration: none;
        color: $color2;
        // transition: color 0.5s;
    }

    // &:hover::after {
    //     width: 100%;
    // }
}

.date-text {
    font-size: 14px;
    color: #aaa;
}

.misc-item {
    font-size: 16px;
}

.footer {
    margin-top: 20px;
    background-color: $blue;
    height: 40px;
    color: white;
}
</style>
